/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { IncidentReportDetailsDtoFromJSON, IncidentReportDetailsDtoToJSON, } from './IncidentReportDetailsDto';
/**
 * Check if a given object implements the SubmitIncidentReportRequest interface.
 */
export function instanceOfSubmitIncidentReportRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function SubmitIncidentReportRequestFromJSON(json) {
    return SubmitIncidentReportRequestFromJSONTyped(json, false);
}
export function SubmitIncidentReportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'incidentReportDetails': !exists(json, 'incidentReportDetails') ? undefined : IncidentReportDetailsDtoFromJSON(json['incidentReportDetails']),
        'userFileIds': !exists(json, 'userFileIds') ? undefined : json['userFileIds'],
        'openDataCrashId': !exists(json, 'openDataCrashId') ? undefined : json['openDataCrashId'],
    };
}
export function SubmitIncidentReportRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'incidentReportDetails': IncidentReportDetailsDtoToJSON(value.incidentReportDetails),
        'userFileIds': value.userFileIds,
        'openDataCrashId': value.openDataCrashId,
    };
}
